import { createContext, type PropsWithChildren, useMemo } from 'react';

import useHttpService from '../hooks/useHttpService';
import ApiService from '../services/ApiService';

export const ApiServiceContext = createContext<ApiService | null>(null);

export function ApiServiceProvider({ children }: PropsWithChildren) {
  const httpService = useHttpService();

  const apiService = useMemo(() => new ApiService(httpService), [httpService]);

  return <ApiServiceContext.Provider value={apiService}>{children}</ApiServiceContext.Provider>;
}
